angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "ALERTS": {
    "VERIFY_PHONE_ID": {
      "HEADER": "Verify your ID",
      "CONTENT": "Please verify your ID to be able to accept bookings and receive payments.",
      "BUTTON": "Verify"
    },
    "PAYOUT_SUCCESS": {
      "HEADER": "Payout completed",
      "CONTENT": "Payout to your bank account is completed. The amount should appear in your bank account within a few working days.",
      "BUTTON": "Ok"
    },
    "CANCEL_BOOKING": {
      "HEADER": "Cancel Booking",
      "CONTENT": "Are you sure you want to cancel this booking request?",
      "BUTTON_ACCEPT": "Yes",
      "BUTTON_DECLINE": "No"
    },
    "CANCEL_TRIP": {
      "HEADER": "Cancel Trip",
      "CONTENT": "Are you sure you want to cancel this trip offer?",
      "BUTTON_ACCEPT": "Yes",
      "BUTTON_DECLINE": "No"
    },
    "DELETE_PHOTO": {
      "CONTENT": "Delete photo?",
      "BUTTON_ACCEPT": "Yes",
      "BUTTON_DECLINE": "No"
    },
    "DELETE_LAST_PHOTO": {
      "HEADER": "Error",
      "CONTENT": "Cannot delete your last photo: It is being used as your profile photo. To delete or change it, you have to add more photos to your profile.",
      "BUTTON": "Ok"
    },
    "SCRIPT_ERROR": {
      "HEADER": "Oops! Something went wrong...",
      "BUTTON_ACCEPT": "Try again"
    }
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/nls/alerts.json
// module id = 81
// module chunks = 24